import React from 'react';
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setFlag} from "../../features/responseSlice";
import HeaderComponent from "../../components/HeaderComponent";
import PendingRequests from "./PendingRequests";
import "./../../utils/Style/pages/Banktransfers.scss";
import SendPaymentRequest from "./SendPaymentRequest";
import SendBulkRequest from "./SendBulkRequest";
import {fetchBranches} from "../../features/branchesSlice";
import BlurLoading from "../../components/BlurLoading";

function PaymentRequest() {
    const {flag} = useSelector((state) => state.transferResponse);

    const [activeButton, setActiveButton] = useState({name: "Pending Requests"});
    const location = useLocation();
    const name = location.state?.name;
    const dispatch = useDispatch();

    const handleButtonClick = (event) => {
        setActiveButton({name: event.target.innerText});
    };

    useEffect(() => {
        if (name !== undefined) {
            setActiveButton({name: name})
        }
    }, []);

    useEffect(() => {
        if ([0, 1, 2].includes(flag)) {
            dispatch(setFlag(null))
            setActiveButton({name: "Pending Requests"});
        }
    }, [flag]);

    useEffect(() => {
        dispatch(fetchBranches());
    }, []);

    return (
        <>
            <HeaderComponent title="Payment Request"/>
            <div className="BanktransfersPage">
                <div className="container-fluid Banktransferscontainer">
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Pending Requests" ? "active" : ""}`}
                                        onClick={handleButtonClick}>Pending Requests
                                </button>
                                <button
                                    className={`navButton ${activeButton.name === "Send Payment Request" ? "active" : ""}`}
                                    onClick={handleButtonClick}>Send Payment Request
                                </button>
                                <button
                                    className={`navButton ${activeButton.name === "Send Bulk Request" ? "active" : ""}`}
                                    onClick={handleButtonClick}>Send Bulk Request
                                </button>

                            </div>

                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>
                    <div className="row pending-content">
                        {activeButton.name === "Pending Requests" && <PendingRequests setActiveButton={setActiveButton}/>}
                        {activeButton.name === "Send Payment Request" && <SendPaymentRequest />}
                        {activeButton.name === "Send Bulk Request" && <SendBulkRequest />}
                    </div>
                </div>
            </div>
            {<BlurLoading/>}
        </>
    );
}

export default PaymentRequest;
